'use client';

import Image from 'next/image';

import { Breadcrumb } from '@/components/ui/breadcrumb.component';
import { Button } from '@/components/ui/button/button.component';
import { Link } from '@/components/ui/link/link.component';
import { Card } from '@/components/ui/card.component';
import { ContentContainer } from '@/components/ui/content-container.component';
import emptyStateSvg from '@/assets/empty-state.svg?url';
import { useErrorBoundaryLogger } from '@/logger/boundary.client';

const breadcrumbsItems = [
  {
    label: 'Profissionais',
  },
];

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useErrorBoundaryLogger('boundary.profissionais-por-letra', error);

  return (
    <>
      <Breadcrumb list={breadcrumbsItems} />
      <ContentContainer className="md:mt-6 sm:my-10 px-0">
        <Card className="max-w-xl mx-auto border-none rounded-2xl md:shadow-floating py-6">
          <div className="flex flex-col items-center justify-center">
            <Image src={emptyStateSvg} alt="Error" width={200} height={200} className="ml-10" />
            <div className="text-center space-y-6 mt-6">
              <h2 className="text-gray-900 text-3xl font-bold">Algo deu errado</h2>
              <p className="mt-4 text-gray-800">
                Não conseguimos carregar as informações dos profissionais. Verifique sua conexão ou tente novamente
                clicando no botão abaixo:
              </p>

              <div className="space-y-4 md:max-w-80 mx-auto">
                <Button onClick={() => reset()}>Tentar novamente</Button>
                <Button asChild variant="secondary">
                  <Link prefetch={false} href="/profissionais/">Página Inicial</Link>
                </Button>
              </div>
            </div>
          </div>
        </Card>
      </ContentContainer>
    </>
  );
}
